// Generated by tutorials/record.cjs from tutorials/articles/h14-switching-facility.cjs.
// Do not edit: change the script and run `node tutorials/record.cjs h14 --text-only` (wording) or
// `node tutorials/record.cjs h14` (pictures and clips).
import type { HelpArticle } from '../types';

const article: HelpArticle = {
  slug: 'switching-facility',
  catalogId: 'h14',
  title: 'Switching facility',
  summary: 'Work in more than one facility? Switch between them from the top of any page, choose the one Dietech opens at sign-in, or open a second facility in its own window.',
  audience: 'Anyone who works in more than one facility, such as a regional dietitian or a manager who covers two buildings',
  area: 'general',
  learn: [
    'Find and switch to another facility',
    'Make a facility your default',
    'Work in two facilities at once, each in its own window',
  ],
  keywords: [
    'switch facility',
    'change facility',
    'facility',
    'facilities',
    'building',
    'another facility',
    'default facility',
    'new window',
    'two facilities',
    'multiple facilities',
  ],
  steps: [
    {
      id: 'open-switcher',
      part: 'Switch to another facility',
      heading: 'Open Switch Facility',
      text: 'Select the facility name at the top right of any page. Switch Facility lists every facility you can work in. The one you are in now is marked Current.',
      media: {
        image: {
          src: '/help/switching-facility/open-switcher.webp',
          width: 1280,
          height: 748,
        },
        clip: {
          src: '/help/switching-facility/open-switcher.mp4',
          width: 1280,
          height: 748,
          durationSec: 2.7,
        },
        alt: 'The Switch Facility list under the facility name: Maple Grove Care Center, marked Current and Default, and Cedar Ridge Health Campus.',
      },
    },
    {
      id: 'search',
      part: 'Switch to another facility',
      heading: 'Find a facility',
      text: 'Have a long list? Type part of a facility\'s name in Search facilities to narrow it.',
      media: {
        image: {
          src: '/help/switching-facility/search.webp',
          width: 672,
          height: 504,
        },
        clip: {
          src: '/help/switching-facility/search.mp4',
          width: 672,
          height: 504,
          durationSec: 2.2,
        },
        alt: 'Search facilities with "cedar" typed, and only Cedar Ridge Health Campus listed.',
      },
    },
    {
      id: 'switch',
      part: 'Switch to another facility',
      heading: 'Switch',
      text: 'Select the facility. Dietech loads it, and its name shows at the top right. You stay on the same page, now for the other facility.',
      media: {
        image: {
          src: '/help/switching-facility/switch.webp',
          width: 1280,
          height: 748,
        },
        clip: {
          src: '/help/switching-facility/switch.mp4',
          width: 1280,
          height: 748,
          durationSec: 4.7,
        },
        alt: 'The dashboard for Cedar Ridge Health Campus, with its name at the top right.',
      },
    },
    {
      id: 'default-star',
      part: 'Your default and a second window',
      heading: 'Make a facility your default',
      text: 'The star marks your default facility, the one Dietech opens when you sign in. Select the star beside another facility to make it your default instead. You can also choose it in your settings.',
      media: {
        image: {
          src: '/help/switching-facility/default-star.webp',
          width: 672,
          height: 602,
        },
        clip: {
          src: '/help/switching-facility/default-star.mp4',
          width: 672,
          height: 602,
          durationSec: 3.2,
        },
        alt: 'Switch Facility with the star beside Cedar Ridge Health Campus now filled in, and Default under its name.',
      },
    },
    {
      id: 'new-window',
      part: 'Your default and a second window',
      heading: 'Two facilities at once',
      text: 'To work in two facilities at the same time, select the box with an arrow beside a facility. It opens in a new window, and each window keeps its own facility.',
      media: {
        image: {
          src: '/help/switching-facility/new-window.webp',
          width: 672,
          height: 602,
        },
        alt: 'The Open in a new window button beside Maple Grove Care Center, marked.',
      },
    },
    {
      id: 'switch-back',
      part: 'Your default and a second window',
      heading: 'Switch back',
      text: 'Switch back the same way: select the facility name at the top, then the facility.',
      media: {
        image: {
          src: '/help/switching-facility/switch-back.webp',
          width: 1280,
          height: 748,
        },
        clip: {
          src: '/help/switching-facility/switch-back.mp4',
          width: 1280,
          height: 748,
          durationSec: 3.5,
        },
        alt: 'The dashboard for Maple Grove Care Center again, with its name at the top right.',
      },
    },
  ],
  tips: [
    'Check the facility name at the top before you change anything, so you change the right building.',
    'Two windows side by side are the easiest way to compare two facilities.',
  ],
  notes: [
    'You only see the facilities you have been given. If one is missing, ask your administrator.',
    'If the page you are on has changes you have not saved, Dietech asks before it switches.',
  ],
  related: ['getting-around', 'settings-and-preferences'],
  recorded: '2026-10-25',
};

export default article;
